<script setup lang="ts">
import SelectProfileType from "../../../../../../../auth/features/registration/ui/web/components/SelectProfileType.vue";

definePageMeta({
  layout: 'cabinet-auth'
});

const {t} = useI18n();
const localePath = useLocalePath();
const router = useRouter();
const config = useRuntimeConfig();

const profileType = ref();
const allowedProfileTypes = computed(() =>
  [...new Set(config.public.auth.allowedProfiles.filter(val => ['employee', 'customer'].includes(val)))]
  ?? []
);
watch(profileType, (selectedProfileType) => {
  navigateTo(localePath(`/cabinet/auth/sign-up/${selectedProfileType}`));
})

onBeforeMount(() => {
  if (allowedProfileTypes.value.length === 1) {
    navigateTo(localePath(`/cabinet/auth/sign-up/${allowedProfileTypes.value[0]}`));
  }
});
</script>

<template>
  <div>
    <h1 class="text-3xl text-gray-800 font-bold mb-6">{{ t('auth.signUpForm.header') }} ✨</h1>

    <SelectProfileType
      v-if="allowedProfileTypes.length > 1"
      :allowed-profile-types="allowedProfileTypes"
      v-model="profileType"
    />
  </div>
</template>

<style scoped>

</style>